import { AuthState } from '@aws-amplify/ui-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import AuthService from 'services/AuthService';

const useAuthStateListener = () => {
    const path = useLocation().pathname.split(`/`).slice(1);

    useEffect(() => {
        switch (path[0]) {
            case ``:
                AuthService.changeAuthState(AuthState.SignIn);
                break;
            case `signup`:
                AuthService.changeAuthState(AuthState.SignUp);
                break;
            case `forgot-password`:
                AuthService.changeAuthState(AuthState.ForgotPassword);
                break;
            case `confirm-sign-up`:
                AuthService.changeAuthState(AuthState.ConfirmSignUp);
                break;
        }
    }, [path]);
};

export default useAuthStateListener;
